/** @jsxImportSource @emotion/react */
import React, { useCallback, useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import Select from 'components/Select'
import * as classes from './styles'

export type BulkActionBase = {
  id: string
  title: string
}

export type BulkActionsProps<BulkAction> = {
  bulkActions: BulkAction[]
  onApply: (bulkAction: BulkAction) => void
  disabled?: boolean
}

export function BulkActions<BulkAction extends BulkActionBase>({
  bulkActions,
  onApply,
  disabled,
}: BulkActionsProps<BulkAction>) {
  const [selectedAction, setSelectedAction] = useState<BulkAction | null>(null)

  useEffect(() => {
    const isSelectedActionExists = bulkActions.find(({ id }) => id === selectedAction?.id)

    if (selectedAction && !isSelectedActionExists) {
      setSelectedAction(null)
    }
  }, [bulkActions, selectedAction])

  const handleApplyClick = useCallback(() => {
    if (!selectedAction || disabled) {
      return
    }

    onApply(selectedAction)
  }, [selectedAction, disabled, onApply])

  return (
    <div css={classes.bulkActionsWrapper}>
      <Select<BulkAction>
        items={bulkActions}
        value={selectedAction}
        onChange={setSelectedAction}
        placeholder="Bulk actions"
        disabled={disabled}
      />
      <Button
        size="large"
        color="blue"
        variant="outlined"
        onClick={handleApplyClick}
        disabled={disabled || !selectedAction}
      >
        Apply
      </Button>
    </div>
  )
}
